import React, { FC } from 'react';
import moment from 'moment';
import { Button } from 'components/ui';
import { Forgotten, Page404, SignInComponent } from 'modules';
import timifyRedSymbol from 'assets/icons/timify-red-symbol.svg';
import { Route, Switch } from 'react-router';
import routesByName from 'constants/routes';
import { links } from 'constants/links';
import { Link, NavLink } from 'react-router-dom';
import classNames from 'classnames';
import { t } from 'utils';
import styles from './AuthComponent.module.scss';

const AuthComponent: FC = () => {
  const currentYear = moment().format('YYYY');

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <Link className={styles.imageLink} to='/'>
          <img className={styles.image} src={timifyRedSymbol} height='85' alt='Timify logo' />
        </Link>
        <Route
          render={({ location }) =>
            location.pathname !== routesByName.auth.forgotten && (
              <div className={styles.buttons}>
                <Button
                  component={NavLink}
                  to={routesByName.auth.index}
                  activeClassName={styles.active}
                  className={classNames(styles.button, styles.loginButton)}
                  color='dark-blue'
                  exact
                >
                  {t('login')}
                </Button>
                <Button
                  id='indercomChat'
                  className={classNames(styles.button, styles.registerButton)}
                  color='dark-blue'
                >
                  {t('request.access')}
                </Button>
              </div>
            )
          }
        />
        <Switch>
          <Route path={routesByName.auth.index} exact>
            <SignInComponent />
          </Route>
          <Route path={routesByName.auth.forgotten} exact>
            <Forgotten />
          </Route>
          <Route path='*'>
            <Page404 />
          </Route>
        </Switch>
      </div>
      <div className={styles.footer}>
        &copy; {currentYear}
        <a className={styles.link} href='##' target='_blank'>
          TIMIFY
        </a>
        .
        <a className={styles.link} href={links.imprint} rel='noreferrer' target='_blank'>
          Imprint
        </a>
        .
        <a className={styles.link} href={links.termsAndConditions} rel='noreferrer' target='_blank'>
          Terms & Conditions
        </a>
      </div>
    </div>
  );
};

export default AuthComponent;
